import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "frame-fit-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M21 8.24h-5a.25.25 0 01-.25-.25V3a.75.75 0 00-1.5 0v5c0 .96.79 1.74 1.75 1.74h5a.75.75 0 000-1.5zM3 15.76h5c.15 0 .26.11.26.25v4.96a.75.75 0 101.5 0V16c0-.97-.78-1.75-1.75-1.75H2.99a.75.75 0 000 1.5zM8.27 8V3a.75.75 0 011.5 0v5c0 .97-.79 1.75-1.75 1.75H3a.75.75 0 110-1.5h5.02c.13 0 .25-.11.25-.25zM14.26 21a.75.75 0 001.5 0v-5c0-.13.11-.24.25-.24h5a.75.75 0 000-1.5h-5c-.97 0-1.75.78-1.75 1.75V21z" }, null, -1)
  ])))
}
export default { render: render }